import { Dispatch, FC, SetStateAction, useEffect } from 'react';
import { PreloadedQuery, UseQueryLoaderLoadQueryOptions } from 'react-relay';
import {
  IndividualStudentReportRoadmapOverallQuery,
  IndividualStudentReportRoadmapOverallQuery$variables,
} from '../../graphQLOperations/__generated__/IndividualStudentReportRoadmapOverallQuery.graphql';
import { IndividualStudentOverallMetergroup } from './IndividualStudentOverallMetergroup';
import { SelectedSkillIndividualReport } from './IndividualReportWrapper';

interface Props {
  id: string;
  queryReferenceRoadmap: PreloadedQuery<IndividualStudentReportRoadmapOverallQuery, Record<string, unknown>>;
  loadRoadmapOverall: (
    variables: IndividualStudentReportRoadmapOverallQuery$variables,
    options?: UseQueryLoaderLoadQueryOptions,
  ) => void;
  currentRoadmap?: { id: string; name?: string | null } | null;
  setSelectedSkill: Dispatch<SetStateAction<SelectedSkillIndividualReport | null>>;
}

export const IndividualStudentRoadmapOverall: FC<Props> = ({
  id,
  loadRoadmapOverall,
  currentRoadmap,
  queryReferenceRoadmap,
  setSelectedSkill,
}) => {
  useEffect(() => {
    loadRoadmapOverall(
      {
        studentId: id,
        roadmapId: currentRoadmap?.id || '',
      },
      { fetchPolicy: 'network-only' },
    );
  }, [id]);

  return (
    <div>
      <h4 className="tw-pb-4 tw-mb-2" style={{ fontFamily: 'Poppins', textDecoration: 'none', fontStyle: 'normal' }}>
        Roadmap progress
      </h4>
      <div className="tw-border-[2px] tw-p-4 tw-border-solid tw-border-neutral-300 tw-rounded-lg">
        {queryReferenceRoadmap && (
          <IndividualStudentOverallMetergroup
            setSelectedSkill={setSelectedSkill}
            queryDataRef={queryReferenceRoadmap}
            currentRoadmap={currentRoadmap}
          />
        )}
      </div>
    </div>
  );
};
